import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { MatrizValor, SalvarMatrizPayload } from './matriz-valor.model';

@Injectable({ providedIn: 'root' })
export class MatrizValorService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<MatrizValor[]>> {
    return this.http.get<ApiResponse<MatrizValor[]>>(`${this.url}/${nrSeqCupom}/matriz-valor`);
  }

  criar(nrSeqCupom: number, payload: SalvarMatrizPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/matriz-valor`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/matriz-valor/${nrSequencia}`);
  }
}
